import { z } from "zod";
/**
 * Factory function to create CreateAccountValidator with translations
 */
export const createCreateAccountValidator = (t) => z.object({
    name: z
        .string()
        .min(1, t("validation.accounts.nameRequired"))
        .max(255, t("validation.accounts.nameTooLong")),
});
/**
 * Factory function to create UpdateAccountValidator with translations
 */
export const createUpdateAccountValidator = (t) => z.object({
    name: z
        .string()
        .min(1, t("validation.accounts.nameRequired"))
        .max(255, t("validation.accounts.nameTooLong")),
});
/**
 * Factory function to create InviteUserValidator with translations
 */
export const createInviteUserValidator = (t) => z.object({
    email: z.email(t("validation.email")),
    role: z.enum(["owner", "admin", "member"]).default("member"),
});
